// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"a2e8a8e5","731":"784754ad","905":"e83107b9"}[chunkId] + ".chunk.js";
};